module.exports = __webpack_public_path__ + "img/DK25804759.dbefb320.png";